import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { STATUS_ICONS } from '../../utils/statusTonePalette.ts';
import {
  avatarSx,
  cardDescriptionSx,
  cardHeaderSx,
  cardSx,
  cardTitleSx,
  reasonsSx,
} from '../OpenXAgentPersonas.styles.ts';
import { getPersonaAvatar, getPersonaAvatarIndex } from '../utils/personaAvatars.ts';
import { getPersonaTone, type Persona } from '../utils/personasPayload.ts';

type OpenXAgentPersonaCardProps = {
  persona: Persona;
};

export const OpenXAgentPersonaCard = ({ persona }: OpenXAgentPersonaCardProps) => {
  // getPersonaAvatarIndex may store a new pick, but returns the same index on every later call, so a repeated run
  // (StrictMode) is harmless
  const avatarIndex = useMemo(() => getPersonaAvatarIndex(persona.id), [persona.id]);
  const Avatar = getPersonaAvatar(avatarIndex, persona.status);
  const tone = getPersonaTone(persona.status);
  const ReasonIcon = STATUS_ICONS[tone];

  return (
    <Box component="li" sx={cardSx(tone)} data-test="persona-card">
      <Box sx={cardHeaderSx}>
        <Avatar sx={avatarSx} />
        <Typography component="h5" sx={cardTitleSx}>
          {persona.title}
        </Typography>
      </Box>
      {persona.description ? <Typography sx={cardDescriptionSx}>{persona.description}</Typography> : null}
      {persona.reasons ? (
        <Typography sx={reasonsSx(tone)}>
          <ReasonIcon />
          {persona.reasons}
        </Typography>
      ) : null}
    </Box>
  );
};
